import { render, staticRenderFns } from "./LbaGridColumn.vue?vue&type=template&id=19e98f75"
import script from "./LbaGridColumn.vue?vue&type=script&lang=js"
export * from "./LbaGridColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports